<div class="quick-presence">
  <div class="quick-presence-header">
    <span class="quick-presence-title">Nouvelle présence</span>
  </div>

  <div class="quick-presence-body">
    <label class="field">
      <span class="field-label">Date</span>
      <input
        type="date"
        class="field-control"
        [ngModel]="date()"
        (ngModelChange)="setDate($event)"
      />
    </label>

    @if (showCalendarSelect()) {
      <label class="field">
        <span class="field-label">Calendrier</span>
        <select class="field-control" [ngModel]="calendarId()" (ngModelChange)="setCalendar($event)">
          @for (calendar of calendars(); track calendar.id) {
            <option [ngValue]="calendar.id">{{ calendar.label }}</option>
          }
        </select>
      </label>
    }

    @if (showLocalisationSelect()) {
      <label class="field">
        <span class="field-label">Lieu</span>
        <select class="field-control" [ngModel]="localisationId()" (ngModelChange)="setLocalisation($event)">
          @for (localisation of localisations(); track localisation.id) {
            <option [ngValue]="localisation.id">{{ localisation.label }}</option>
          }
        </select>
      </label>
    }

    <label class="field">
      <span class="field-label">Moment de la journée</span>
      <select class="field-control" [ngModel]="portion()" (ngModelChange)="setPortion($event)">
        @for (option of portionOptions; track option.value) {
          <option [ngValue]="option.value">{{ option.label }}</option>
        }
      </select>
    </label>

    @if (isCustomPortion()) {
      <label class="field">
        <span class="field-label">Plage horaire</span>
        <input
          type="text"
          class="field-control"
          placeholder="08:00 - 12:00"
          [ngModel]="customPortion()"
          (ngModelChange)="setCustomPortion($event)"
        />
      </label>
    }

    @if (conflictError()) {
      <p class="quick-presence-error">{{ conflictError() }}</p>
    }
  </div>

  <div class="quick-presence-footer">
    <button type="button" class="btn btn-ghost" (click)="dismissed.emit()">
      Annuler
    </button>
    <button type="button" class="btn btn-primary" [disabled]="!canSubmit()" (click)="submit()">
      @if (loading()) {
        Ajout…
      } @else {
        Ajouter ma présence
      }
    </button>
  </div>
</div>
